import { Box, Typography } from '@mui/material';
import React from 'react';

import { TickIcon } from '@/assets/svg';
import { t } from '@/services/translations/config';
import { COLOR } from '@/theme/colors';

import { Props } from './types';

const PlanBenefits: React.FC<Props> = ({ benefits, title }) => {
    return (
        <Box sx={{ padding: '26px' }}>
            <Typography
                fontSize={12}
                fontWeight={700}
                color={COLOR.riverBed}
                mb={2}
            >
                {title}:
            </Typography>

            {benefits.map((benefit, index) => (
                <Box
                    key={index}
                    sx={{
                        display: 'flex',
                        gap: '4px',
                        mb: '4px',
                    }}
                >
                    <Box sx={{ flexShrink: 0, mt: '6px' }}>
                        <TickIcon color={COLOR.black} width={16} height={16} />
                    </Box>

                    <Box color={COLOR.slateGray}>
                        {benefit.prefix && (
                            <Typography
                                fontWeight={700}
                                fontSize={12}
                                component="span"
                            >
                                {t(benefit.prefix)}:{' '}
                            </Typography>
                        )}

                        <Typography fontSize={12} component="span">
                            {t(benefit.text)}
                        </Typography>

                        {benefit.suffix && (
                            <Typography
                                fontWeight={700}
                                fontSize={12}
                                component="span"
                            >
                                {t(benefit.suffix)}
                            </Typography>
                        )}
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default PlanBenefits;
